import React from 'react';
import PrivacyPolicyPage from './PrivacyPolicyPage';

// This wrapper is now handled directly in PrivacyPolicyPage.tsx
// with PrivacyPolicyPageWithNavigation component
const PrivacyPolicyPageWrapper = () => {
  return <PrivacyPolicyPage />;
};

export default PrivacyPolicyPageWrapper;
